import Http from 'axios'
import {VERSIONED_API_URL} from '../../config/config'

function initialState() {
    return {
        all: [],
        query: '',
        exportUrl: '',
        filter: '',
        loading: false,
        visa_type_conditions: [],
        visa_type_condition: {
            id: null,
            name: '',
            cost: 0,
            days: 0,
            passport_type: null,
            country: null,
            age: null,
            visa_sticker_type: null,
            apply_type: null,
            free_first_time: 0,
            extendable: 1,
            count_in_visa_year: 1,
            general: 0,
            dependent: 0,
            documents: [],
            dependent_documents: [],
            costs: [],
            dependent_cost: null,
            active: 1
        },
        price_generator: {
            days: null,
            cost: null,
            plan: null,
            number: null,
            late_stay_cost: null
        },
        visa_type: null,
        modelName: 'visa-types-conditions'
    }
}

const getters = {
    all: state => state.all,
    loading: state => state.loading,
    serverPagination: state => state.serverPagination,
    filter: state => state.filter,
    query: state => state.query,
    totalNumber: state => state.totalNumber,
    visa_type_condition: state => state.visa_type_condition,
    price_generator: state => state.price_generator
};


const actions = {
    fetchAll({state, commit}, visa_type = null) {
        commit('setLoading', true);
        let query = '';
        if (visa_type) {
            query += '?visa_type=' + visa_type
        }
        Http.get(`${VERSIONED_API_URL}/${state.modelName}${query}`).then((response) => {
            commit('setAll', response.data.data)
            commit('setLoading', false)
        })
    },
    create({state, commit}) {
        let costs = state.visa_type_condition.costs;
        for (let i = 0; i < costs.length; i++) {
            costs[i].cost = parseFloat(costs[i].cost)
            costs[i].late_stay_cost = parseFloat(costs[i].late_stay_cost)
        }
        state.visa_type_condition.costs = costs;
        return new Promise((resolve, reject) => {
            commit('setLoading', true)
            Http.post(`${VERSIONED_API_URL}/${state.modelName}`, state.visa_type_condition).then(() => {
                commit('setLoading', false);
                commit('resetState');
                resolve(true)
            }).catch((error) => {
                commit('setLoading', false);
                reject(error)
            })
        })
    },
    show({state, commit}, id) {
        commit('setLoading', true)
        Http.get(`${VERSIONED_API_URL}/${state.modelName}/${id}`).then((response) => {
            commit('setLoading', false);
            let data = response.data.data;
            let costs = data.days_cost;
            for (let i = 0; i < costs.length; i++) {
                costs[i].plan = parseInt(costs[i].plan)
            }
            data.costs = costs;
            data.visa_type = data.visa_type_id;
            commit('setModel', data)
        })
    },
    update({state, commit}) {
        commit('setLoading', true)
        let costs = state.visa_type_condition.costs;
        for (let i = 0; i < costs.length; i++) {
            costs[i].cost = parseFloat(costs[i].cost)
            costs[i].late_stay_cost = parseFloat(costs[i].late_stay_cost)
        }
        state.visa_type_condition.costs = costs;
        console.log(state.visa_type_condition.costs)
        return new Promise((resolve, reject) => {
            Http.put(`${VERSIONED_API_URL}/${state.modelName}/${state.visa_type_condition.id}`, state.visa_type_condition).then((res) => {
                commit('setLoading', false);
                commit('resetState')

                resolve(true)
            }).catch((err) => {
                commit('setLoading', false);
                reject(err)
            })
        })
    },
    delete({state, commit}, ids) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true);

            for (let id of ids) {
                Http.delete(`${VERSIONED_API_URL}/${state.modelName}/${id}`).then((res) => {
                    commit('setLoading', false)
                    resolve(res)
                }).catch((err) => {
                    commit('setLoading', false)
                    reject(err)
                })
            }

        })

    }
}


const mutations = {
    setAll(state, items) {
        state.all = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setModel(state, item) {
        state.visa_type_condition = item;
    },
    setQuery(state, query) {
        state.query = query
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    setFilter(state, item) {
        state.filter = item
    },
    addVisaTypeConditionCost(state) {
        state.visa_type_condition.costs.push({
            days: null,
            cost: null,
            late_stay_cost: null
        })
    },
    removeVisaTypeConditionCost(state, index) {
        state.visa_type_condition.costs.splice(index, 1);
    },
    addVisaTypeConditionDocument(state) {
        state.visa_type_condition.documents.push({
            document: null,
            required: 1,
            show_front: 1,
            autofill: 0,
        })
    },
    removeVisaTypeConditionDocument(state, index) {
        state.visa_type_condition.documents.splice(index, 1);
    },
    addVisaTypeConditionDependentDocument(state) {
        state.visa_type_condition.dependent_documents.push({
            document: null,
            required: 1,
            show_front: 1
        })
    },
    removeVisaTypeConditionDependentDocument(state, index) {
        state.visa_type_condition.dependent_documents.splice(index, 1);
    },
    generatePrice(state) {
        let price_generator = state.price_generator;
        let prices = state.visa_type_condition.costs;
        for (let i = 0; i < price_generator.number; i++) {
            prices.push({
                days: price_generator.days * (i + 1),
                cost: (price_generator.cost * (i + 1)).toString(),
                late_stay_cost: price_generator.late_stay_cost * (i + 1),
                plan: price_generator.plan
            })
        }
        console.log(prices);
        state.visa_type_condition.costs = prices;
    }

};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
